import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { ProgramSpace } from '../types'
import TimetableItem from './TimetableItem'
import config from '../config'
import { mapGetDayWidthToProps } from '../redux/selectors'
import colors from '../../../constants/colors'

interface StyledAreaRowProps {
    index: number
}
interface StyledItemWrapperProps {
    dayWidth: number
}

const S = {
    AreaRow: styled.div<StyledAreaRowProps>`
        display: flex;
        flex-direction: row;
        overflow: hidden;
        height: ${config.rowHeight}px;
        background-color: ${({ index }) => ['transparent', colors.gray1][index % 2]};
        &:last-child {
            height: ${config.rowHeight + 3}px; // To avoid scroll bar overlap the item
        }
    `,
    ItemWrapper: connect(mapGetDayWidthToProps)(styled.div<StyledItemWrapperProps>`
        position: absolute;
        width: ${({ dayWidth }) => dayWidth}px;
        height: ${config.rowHeight}px;
        overflow: hidden;
    `),
}

const AreaItemsRow = ({ area, index }: {area: ProgramSpace, index: number}) => (
    <S.AreaRow index={index}>
        <S.ItemWrapper>
            { area.items.map(({id, ...props}) => (
                <TimetableItem key={id} id={id} {...props} />
            )) }
        </S.ItemWrapper>
    </S.AreaRow>
)

export default AreaItemsRow
